import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { VideoStreamingService } from 'src/app/features/video/controller/video-streaming.service';
import { VideoSearchResult } from 'src/app/features/video/model/video-search-result.model';
import { VideoPlayerComponent } from '../../features/video/view/video-player/video-player.component';
import { MultiItemCard } from 'src/app/features/handball/cards/model/card';
import { Scene } from 'src/app/features/video/model/scene';
import { MatIcon } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { CardComponent } from 'src/app/features/handball/cards/view/horizontal-card/horizontal-card.component';

@Component({
  selector: 'app-video-watch-page',
  templateUrl: './video-watch-page.component.html',
  styleUrls: ['./video-watch-page.component.scss'],
  standalone: true,
  imports: [CommonModule, VideoPlayerComponent, CardComponent, MatIcon],
})
export class VideoWatchPageComponent implements OnInit {

  video: VideoSearchResult = null;
  card: MultiItemCard = null;
  exportingToXps = false;
  exportToXpsLabel = 'Exportar a XPS';
  isSceneLoaded = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private videoStreamingService: VideoStreamingService
  ) {
    const state = this.router.getCurrentNavigation()?.extras.state as {
      video: VideoSearchResult;
    };
    if (state?.video) {
      this.video = state.video;
    }
  }

  async ngOnInit() {
    if (!this.video) {
      await this.loadVideo();
    }
  }

  isLoading(): boolean {
    return !(this.video && this.isSceneLoaded)
  }

  sceneSelected(scene: Scene) {
    this.getSceneData(scene);
  }

  scenesLoaded() {
    this.isSceneLoaded = true;
  }

  cardChanges(card: MultiItemCard) {
    this.card = card;
  }

  cardDeleted(card: MultiItemCard) {
    this.card = null;
    console.log('Card deleted', card);
  }

  async exportToXps($event: Event) {
    $event.stopPropagation();
    $event.preventDefault();

    this.exportingToXps = true;
    this.exportToXpsLabel = 'Exportando...';
    await new Promise((resolve) => setTimeout(resolve, 5000));
    this.downloadCsv();
    this.exportToXpsLabel = 'Exportado a XPS';
    await new Promise((resolve) => setTimeout(resolve, 1000));
    this.exportingToXps = false;
    this.exportToXpsLabel = 'Exportar a XPS';
  }

  private downloadCsv() {
    const filename = `${this.video.title}_${this.video.id}.csv`;
    const header = 'Jugada,Fase,Item,Valor\n';

    const fase = this.card.label.split('-')[0].trim();
    const jugada = this.card.label.split('-')[1]?.trim() || fase;
    const body = this.card.items
      .map((item) => `${jugada},${fase},${item.label},${item.value}`)
      .join('\n');
    const workInProgressRow = `"Este CSV es un ejemplo de exportación, no contiene datos reales.",,,\n`;

    const csvData = header + body + '\n' + workInProgressRow;

    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  private async loadVideo() {
    const videoId: string = await new Promise((resolve) => {
      this.route.params.subscribe((params) => {
        resolve(params['id']);
      });
    });
    this.video = await this.videoStreamingService.getVideoById(videoId);
  }

  private getSceneData(scene: Scene) {

    const items = [];

    for (const data of scene.data || []) {
      if (data.label && data.value) {
        items.push({ label: data.label, value: data.value });
      }
    }

    this.card = {
      id: 'video-card-' + scene.title,
      label: scene.title,
      items: items,
    };
  }
}
